export const formatPrice = (amount, currency, currencySymbol) => {
  const numericAmount = Number(amount);
  if (isNaN(numericAmount)) {
    return '';
  }
  const formattedAmount = numericAmount.toFixed(2);
  if (currency === 'CAD') {
    return `${formattedAmount} ${currencySymbol}`;
  }
  return `${currencySymbol}${formattedAmount}`;
};